import {connect} from "react-redux"
import {createSelector} from "reselect"
import {screenIsSmallerThanLarge} from "../../utils/window"
import {State} from "../../ducks"
import {setPrimaryNavIndex, setIsInPrimaryNav} from "../../ducks/primary-nav"
import {getSecondaryNavDataThunk, setIsInTertiaryNav, setTertiaryNavIndex} from "../../ducks/secondary-nav"
import {ExcludeFrom} from "../../models/excludeFrom"
import {excludeFromNarrowView, excludeFromWideView} from "../../utils/excludeFrom"
import {EXCLUDE_FROM_WIDEVIEW_CLASS, EXCLUDE_FROM_NARROWVIEW_CLASS, NAV_VIEWTYPE} from "../../config/constants"

const hasPrimaryNavbarLink = (viewType?: string) => {
    return viewType === NAV_VIEWTYPE.PRIMARY_NAVBAR_LINK
}

const classNames = (excludeFrom?: ExcludeFrom) => {
    // Note: We create classes for excluding primary nav items in the SnailTrail to prevent flicker on Client Side Hydration given this behaviour is dependant on the use of a media query
    let classes = ""
    if (!excludeFrom || excludeFrom.length <= 0) {
        return classes
    }

    classes += excludeFrom.some(excludeFromNarrowView) ? `${EXCLUDE_FROM_NARROWVIEW_CLASS} ` : ""
    classes += excludeFrom.some(excludeFromWideView) ? `${EXCLUDE_FROM_WIDEVIEW_CLASS} ` : ""
    return classes
}

const selectDisplayItems = createSelector(
    (state: State) => state.primarynav.items,
    items =>
        items.map(item => ({
            ...item,
            classNames: classNames(item?.excludeFrom),
        })),
)

export const mapStateToProps = (state: State) => {
    const {items, activeDepartmentIndex, isInPrimaryNav, alignment} = state.primarynav
    const dir = state.textAlignment
    const {rememberSelectedDepartment} = state.settings
    const {template} = state

    const showSecondaryNav = hasPrimaryNavbarLink(state.primarynav.items[activeDepartmentIndex]?.viewType)

    if (!items || items.length === 0) {
        throw new Error("Meganav: there is no primary data for meganav")
    }

    return {
        dir,
        items: selectDisplayItems(state),
        activeDepartmentIndex,
        isInPrimaryNav,
        rememberSelectedDepartment,
        alignment,
        showSecondaryNav,
        templating: template,
    }
}

export const mapDispatchToProps = dispatch => ({
    hasPrimaryNavbarLink,
    setActiveItem: (
        index: number,
        item: {title: string; path: string; viewType?: string},
        activeDepartmentIndex: number,
    ): void => {
        const isAlreadyActive = index >= 0
        const isNotTheSameIndex = activeDepartmentIndex !== index
        if ((isAlreadyActive && isNotTheSameIndex) || screenIsSmallerThanLarge()) {
            dispatch(setPrimaryNavIndex(index, item.title))
            if (index > -1 && !hasPrimaryNavbarLink(item.viewType)) dispatch(getSecondaryNavDataThunk(item.path))
        }
    },
    setIsInPrimaryNav: (value: boolean, item?: {title: string; path: string; viewType?: string}) => {
        if (!hasPrimaryNavbarLink(item?.viewType)) dispatch(setIsInPrimaryNav(value))
    },
    closeTertiaryNav: () => {
        dispatch(setIsInTertiaryNav(false))
        dispatch(setTertiaryNavIndex(-1))
    },
})

export default connect(mapStateToProps, mapDispatchToProps)
